import React from "react";

export default function HackCMU2026() {
  return (
    <div class="welcome">
      <span class="text">
        <div class="container">
          <div class="title" id="welcometext">
            HackCMU_2026
          </div>
          <div class="infotext">
            Coming soon. Stay tuned for more details!
          </div>
        </div>
      </span>
    </div>
  );
}
